/*
         * @ngdoc function
         * @name ePay.Model:Session_ePaySessionModel
         * @description
         * Model
         */
import { Session_XMLPaymentModel } from './Session_XMLPaymentModel';
import { Session_PaymentPageModel } from './Session_PaymentPageModel';
import { Session_IOTPModel } from './Session_IOTPModel';
import { SettingsModel } from './SettingsModel';
import { Session_AppleRequestModel } from './Session_AppleRequestModel';

export class Session_ePaySessionModel {
	xmlPayment: Session_XMLPaymentModel;
	paymentPage: Session_PaymentPageModel;
	iotp: Session_IOTPModel;
  page: string | null | undefined;
	settings: SettingsModel;
	apple: Session_AppleRequestModel;

	constructor(
		xmlPayment?: Session_XMLPaymentModel, 
		paymentPage?: Session_PaymentPageModel, 
		iotp?: Session_IOTPModel, 
		page?: string, 
		settings?: SettingsModel, 
		apple?: Session_AppleRequestModel
	) {
		this.xmlPayment = xmlPayment || new Session_XMLPaymentModel();
		this.paymentPage = paymentPage || new Session_PaymentPageModel();
		this.iotp = iotp || new Session_IOTPModel();
		this.page = page || null;
		this.settings = settings || new SettingsModel();
		this.apple = apple || new Session_AppleRequestModel();
	}
}
